<template>
  <form
    v-on:submit.prevent="$route.name == 'ficha' ? false : saveForm()"
    novalidate
  >
    <LoaderContent v-if="isLoading" :welcomeMessage="false" />

    <div class="form-row">
      <InputAvatar
        v-if="$route.name == 'ficha'"
        class="input-avatar-container"
      />

      <div
        class="form-group col-12 col-sm-6 col-md-4 gender-container mb-4"
        :class="{ 'is-invalid': $v.pronoun.$error }"
      >
        <div>
          <label :for="'personal-input-pronoun' + _uid"
            ><span>*</span>Pronome adequado para você?</label
          >
          <span
            class="btn btn-sm p-0 align-middle ml-1"
            @click="showModalDiversityInput()"
            ><icon-help-circle-outline
          /></span>
        </div>

        <selectize
          :id="'personal-input-pronoun' + _uid"
          :settings="pronounSettings"
          v-model="pronoun"
        >
          <option
            :value="pronoun.id"
            v-for="(pronoun, index) in $store.state.domains.pronouns"
            :key="index"
          >
            {{ pronoun.description }}
          </option>
        </selectize>
      </div>

      <div
        class="form-group col-12 col-sm-6 col-md-4 firstname-container mb-4"
        :class="{ 'is-invalid': $v.firstname.$error }"
      >
        <div>
          <label :for="'personal-input-first-name' + _uid"
            ><span>*</span> Nome</label
          >
        </div>

        <input
          type="text"
          class="form-control"
          :id="'personal-input-first-name' + _uid"
          v-model="firstname"
        />
      </div>

      <div
        class="form-group col-12 col-sm-6 col-md-4 lastname-container mb-4"
        :class="{ 'is-invalid': $v.lastname.$error }"
      >
        <div>
          <label :for="'personal-input-last-name' + _uid"
            ><span>*</span> Sobrenome</label
          >
        </div>

        <input
          type="text"
          class="form-control"
          :id="'personal-input-last-name' + _uid"
          v-model="lastname"
        />
      </div>

      <div
        class="form-group col-12 col-sm-6 col-md-4 socialName-container mb-4"
        :class="{ 'is-invalid': $v.socialName.$error }"
      >
        <div>
          <label :for="'personal-input-social-name' + _uid">Nome social</label>
          <span
            class="btn btn-sm p-0 align-middle ml-1"
            @click="showModalDiversityInput()"
            ><icon-help-circle-outline
          /></span>
        </div>

        <input
          type="text"
          class="form-control"
          :id="'personal-input-social-name' + _uid"
          v-model="socialName"
        />
      </div>

      <div
        class="form-group col-12 col-sm-6 col-md-4 email-container mb-4"
        :class="{ 'is-invalid': $v.email.$error }"
      >
        <div>
          <label :for="'personal-input-email' + _uid"
            ><span>*</span> E-mail</label
          >
        </div>

        <input
          type="email"
          class="form-control"
          :id="'personal-input-email' + _uid"
          v-model="email"
        />
      </div>

      <div
        class="form-group col-12 col-sm-6 col-md-4 phone-container mb-4"
        :class="{ 'is-invalid': $v.phone.$error }"
      >
        <div>
          <label :for="'personal-input-phone' + _uid"
            ><span>*</span> Celular</label
          >
        </div>

        <the-mask
          type="tel"
          class="form-control"
          :id="'personal-input-phone' + _uid"
          :mask="['(##) ####-####', '(##) #####-####']"
          v-model="phone"
        />
      </div>

      <div
        class="
          form-group
          col-12 col-sm-6 col-md-4
          raceAndEthnicity-container
          mb-4
        "
        :class="{ 'is-invalid': $v.raceAndEthnicity.$error }"
      >
        <div>
          <label :for="'personal-input-raceAndEthnicity' + _uid"
            ><span>*</span>Raça/Etnia</label
          >
          <span
            class="btn btn-sm p-0 align-middle ml-1"
            @click="showModalDiversityInput()"
            ><icon-help-circle-outline
          /></span>
        </div>

        <selectize
          :id="'personal-input-raceAndEthnicity' + _uid"
          :settings="raceAndEthnicitySettings"
          v-model="raceAndEthnicity"
        >
          <option
            :value="raceAndEthnicity.id"
            v-for="(raceAndEthnicity, index) in $store.state.domains
              .race_and_ethnicities"
            :key="index"
          >
            {{ raceAndEthnicity.description }}
          </option>
        </selectize>
      </div>

      <div
        class="form-group col-12 col-sm-6 col-md-4 gender-container mb-4"
        :class="{ 'is-invalid': $v.gender.$error }"
      >
        <div>
          <label :for="'personal-input-gender' + _uid"
            ><span>*</span> Sua identidade de gênero</label
          >
          <span
            class="btn btn-sm p-0 align-middle ml-1"
            @click="showModalDiversityInput()"
            ><icon-help-circle-outline
          /></span>
        </div>

        <selectize
          :id="'personal-input-gender' + _uid"
          :settings="genderSettings"
          v-model="gender"
        >
          <option
            :value="gender.id"
            v-for="(gender, index) in $store.state.domains.genders"
            :key="index"
          >
            {{ gender.description }}
          </option>
        </selectize>
      </div>

      <div
        class="
          form-group
          col-12 col-sm-6 col-md-4
          sexualOrientation-container
          mb-4
        "
        :class="{ 'is-invalid': $v.sexualOrientation.$error }"
      >
        <div>
          <label :for="'personal-input-sexual-orientation' + _uid"
            ><span>*</span> Orientação sexual</label
          >
          <span
            class="btn btn-sm p-0 align-middle ml-1"
            @click="showModalDiversityInput()"
            ><icon-help-circle-outline
          /></span>
        </div>

        <selectize
          :id="'personal-input-sexual-orientation' + _uid"
          :settings="sexualOrientationSettings"
          v-model="sexualOrientation"
        >
          <option
            :value="sexualOrientation.id"
            v-for="(sexualOrientation, index) in $store.state.domains
              .sexual_orientations"
            :key="index"
          >
            {{ sexualOrientation.description }}
          </option>
        </selectize>
      </div>

      <div
        class="form-group col-12 col-sm-6 col-md-4 birthday-container mb-4"
        :class="{ 'is-invalid': $v.birthday.$error }"
      >
        <div>
          <label :for="'personal-input-birthday' + _uid"
            ><span>*</span> Data de nascimento</label
          >
        </div>

        <the-mask
          type="tel"
          class="form-control"
          :id="'personal-input-birthday' + _uid"
          :mask="'##/##/####'"
          :masked="true"
          v-model="birthday"
        />
        <small class="form-text text-danger" v-if="birthdayMessage">{{
          birthdayMessage
        }}</small>
      </div>

      <div
        class="form-group col-12 col-sm-6 col-md-4 nationality-container mb-4"
        :class="{ 'is-invalid': $v.nationality.$error }"
      >
        <div>
          <label :for="'personal-input-nationality' + _uid"
            ><span>*</span> Nacionalidade</label
          >
        </div>

        <selectize
          :id="'personal-input-nationality' + _uid"
          :settings="nationalitySettings"
          v-model="nationality"
        >
          <option
            :value="country.name"
            v-for="(country, index) in $store.state.domains.countries"
            :key="index"
          >
            {{ country.name }}
          </option>
        </selectize>
      </div>

      <div
        class="form-group col-12 col-sm-6 col-md-4 document-container mb-4"
        :class="{ 'is-invalid': $v.cpf.$error || $v.passport.$error }"
      >
        <div>
          <label :for="'personal-input-document' + _uid"
            ><span>*</span> {{ isForeign ? "RNE" : "CPF" }}</label
          >
        </div>

        <the-mask
          v-if="!isForeign"
          type="tel"
          class="form-control"
          :id="'personal-input-document' + _uid"
          mask="###.###.###-##"
          v-model="cpf"
          :readOnly="cpfReadOnly"
        />
        <input
          v-else
          type="text"
          class="form-control"
          :id="'personal-input-document' + _uid"
          v-model="passport"
          :readOnly="passportReadOnly"
        />
      </div>

      <div
        class="
          form-group
          col-12 col-sm-6 col-md-4
          personalIncome-container
          mb-4
        "
        :class="{ 'is-invalid': $v.personalIncome.$error }"
      >
        <div>
          <label :for="'personal-input-personalIncome' + _uid"
            ><span>*</span> Sua renda mensal</label
          >
          <span
            class="btn btn-sm p-0 align-middle ml-1"
            @click="showModalDiversityInput()"
            ><icon-help-circle-outline
          /></span>
        </div>

        <selectize
          :id="'personal-input-personalIncome' + _uid"
          :settings="personalIncomeSettings"
          v-model="personalIncome"
        >
          <option
            :value="personalIncome.id"
            v-for="(personalIncome, index) in $store.state.domains
              .personal_incomes"
            :key="index"
          >
            {{ personalIncome.description }}
          </option>
        </selectize>
      </div>

      <div
        class="form-group col-12 col-sm-6 col-md-4 familyIncome-container mb-4"
        :class="{ 'is-invalid': $v.familyIncome.$error }"
      >
        <div>
          <label :for="'personal-input-familyIncome' + _uid"
            ><span>*</span> Sua renda familiar</label
          >
          <span
            class="btn btn-sm p-0 align-middle ml-1"
            @click="showModalDiversityInput()"
            ><icon-help-circle-outline
          /></span>
        </div>

        <selectize
          :id="'personal-input-familyIncome' + _uid"
          :settings="familyIncomeSettings"
          v-model="familyIncome"
        >
          <option
            :value="familyIncome.id"
            v-for="(familyIncome, index) in $store.state.domains.family_incomes"
            :key="index"
          >
            {{ familyIncome.description }}
          </option>
        </selectize>
      </div>

      <div
        class="
          form-group
          col-12 col-sm-6 col-md-4
          marital-status-container
          mb-4
        "
      >
        <div>
          <label :for="'personal-input-marital-status' + _uid"
            >Estado civíl</label
          >
        </div>

        <selectize
          :id="'personal-input-marital-status' + _uid"
          :settings="maritalStatusSettings"
          v-model="maritalStatus"
        >
          <option
            :value="status.id"
            v-for="(status, index) in $store.state.domains.maritalStatus"
            :key="index"
          >
            {{ status.description }}
          </option>
        </selectize>
      </div>

      <FormQuestions class="col-12" v-if="$route.name == 'ficha'" />

      <div class="form-group col-12 divider-container">
        <hr />
      </div>

      <div class="form-group col-12 d-flex flex-wrap mb-3">
        <div>
          <label class="mb-0 mr-3">Possui alguma deficiência?</label>
        </div>

        <div class="">
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              :id="'personal-input-disability-true' + _uid"
              class="custom-control-input"
              v-model="has_disability"
              :value="true"
            />
            <label
              class="custom-control-label"
              :for="'personal-input-disability-true' + _uid"
              >Sim</label
            >
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              :id="'personal-input-disability-false' + _uid"
              class="custom-control-input"
              v-model="has_disability"
              :value="false"
            />
            <label
              class="custom-control-label"
              :for="'personal-input-disability-false' + _uid"
              >Não</label
            >
          </div>
        </div>
      </div>

      <div class="form-group col-12 mb-4" v-show="has_disability == true">
        <div class="row mx-0 d-flex align-items-center justify-content-between">
          <div
            class="
              col-12 col-sm-5 col-md-3
              mb-2
              custom-control custom-checkbox custom-control-inline
            "
            :class="{
              'is-invalid': $v.disabilities.$error && has_disability == true,
            }"
            v-for="(deficiency, index) in $store.state.domains.disabilities"
            :key="index"
          >
            <input
              type="checkbox"
              class="custom-control-input"
              :id="'personal-input-disability-' + _uid + deficiency.id"
              v-model="disabilities"
              :value="deficiency.id"
            />
            <label
              class="custom-control-label"
              :for="'personal-input-disability-' + _uid + deficiency.id"
              >{{ deficiency.name }}</label
            >
          </div>
        </div>
        <MedicalReport v-on:isLoading="(isL) => (isLoading = isL)" />
      </div>

      <div class="form-group col-12 d-flex flex-wrap" v-if="has_disability">
        <div>
          <label class="mb-0 mr-3"
            >Você tem alguma necessidade de ajuda durante o processo de
            seleção?</label
          >
        </div>

        <div class="">
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              :id="'personal-input-need-help-selection-process-true' + _uid"
              class="custom-control-input"
              v-model="need_help_selection_process"
              :value="true"
            />
            <label
              class="custom-control-label"
              :for="'personal-input-need-help-selection-process-true' + _uid"
              >Sim</label
            >
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              :id="'personal-input-need-help-selection-process-false' + _uid"
              class="custom-control-input"
              v-model="need_help_selection_process"
              :value="false"
            />
            <label
              class="custom-control-label"
              :for="'personal-input-need-help-selection-process-false' + _uid"
              >Não</label
            >
          </div>
        </div>
      </div>

      <div class="form-group col-12 mb-4" v-if="need_help_selection_process">
        <textarea
          type="text"
          class="form-control"
          v-model="description_help_selection_process"
          placeholder="Digite aqui algum suporte especial que sua característica como PCD demande durante a participação no recrutamento (ex.: descrição de texto em áudios, aumento de tamanho dos textos, etc.)"
          :id="'personal-input-description_help_selection_process' + _uid"
          rows="5"
          maxlength="100"
        ></textarea>
        <span
          :class="
            description_help_selection_process.length == '100' ? 'limiter' : ''
          "
        >
          <small> {{ caharactersLeft }} </small>
        </span>
      </div>

      <div class="form-group col-12 divider-container">
        <hr />
      </div>

      <div
        class="form-group col-12 col-md-6 mb-4"
        :class="{ 'is-invalid': $v.zipcode.$error }"
      >
        <div>
          <label :for="'personal-input-zip-code' + _uid"
            ><span>*</span> CEP</label
          >
        </div>

        <the-mask
          type="tel"
          class="form-control"
          :id="'personal-input-zip-code' + _uid"
          :mask="'#####-###'"
          v-model="zipcode"
          @keyup.native="getAddress()"
        />
      </div>

      <div
        class="form-group col-12 col-md-6 mb-4"
        :class="{ 'is-invalid': $v.street.$error }"
      >
        <div>
          <label :for="'personal-input-street' + _uid"
            ><span>*</span> Rua</label
          >
        </div>
        <input
          type="text"
          class="form-control"
          :id="'personal-input-street' + _uid"
          v-model="street"
        />
      </div>

      <div
        class="form-group col-12 col-md-4 mb-4"
        :class="{ 'is-invalid': $v.number.$error }"
      >
        <div>
          <label :for="'personal-input-number' + _uid"
            ><span>*</span> Número</label
          >
        </div>
        <input
          type="text"
          class="form-control"
          :id="'personal-input-number' + _uid"
          v-model="number"
        />
      </div>

      <div class="form-group col-12 col-md-4 mb-4">
        <div>
          <label :for="'personal-input-complement' + _uid">Complemento</label>
        </div>
        <input
          type="text"
          class="form-control"
          :id="'personal-input-complement' + _uid"
          v-model="complement"
        />
      </div>

      <div
        class="form-group col-12 col-md-4 mb-4"
        :class="{ 'is-invalid': $v.neighborhood.$error }"
      >
        <div>
          <label :for="'personal-input-neighborhood' + _uid"
            ><span>*</span> Bairro</label
          >
        </div>

        <input
          type="text"
          class="form-control"
          :id="'personal-input-neighborhood' + _uid"
          v-model="neighborhood"
        />
      </div>

      <div
        class="form-group col-12 col-md-6 mb-4"
        :class="{ 'is-invalid': $v.state.$error }"
      >
        <div>
          <label :for="'personal-input-state' + _uid"
            ><span>*</span> Estado</label
          >
        </div>

        <selectize
          :id="'personal-input-state' + _uid"
          :settings="stateSettings"
          v-model="state"
        >
          <option
            :value="state.id"
            v-for="(state, index) in $store.state.domains.states"
            :key="index"
          >
            {{ state.name }}
          </option>
        </selectize>
      </div>

      <div
        class="form-group col-12 col-md-6 mb-4"
        :class="{ 'is-invalid': $v.city.$error }"
      >
        <div>
          <label :for="'personal-input-city' + _uid"
            ><span>*</span> Cidade</label
          >
        </div>
        <selectize
          :id="'personal-input-city' + _uid"
          :settings="citySettings"
          v-model="city"
        >
          <option
            :value="$helpers.cleanStringToCompare(city.name)"
            v-for="(city, index) in $store.state.domains.cities"
            :key="index"
          >
            {{ $helpers.toTitle(city.name) }}
          </option>
        </selectize>
      </div>

      <div class="form-group col-12 divider-container">
        <hr />
      </div>

      <div class="form-group col-12" mb-4>
        <div>
          <label :for="'personal-input-resume' + _uid"
            >Tem algo mais que você considera importante contar sobre
            você?</label
          >
        </div>
        <textarea
          type="text"
          class="form-control"
          placeholder="Escreva aqui um resumo com destaque as características relevantes para atenção dos recrutadores."
          :id="'personal-input-resume' + _uid"
          rows="5"
          v-model="whatDoYouLove"
        ></textarea>
      </div>
    </div>

    <p class="small text-right font-italic">Campos com * são obrigatórios.</p>

    <div class="d-flex align-items-center mt-4" v-if="hasButtons">
      <button type="reset" class="btn btn-light mr-auto" @click="reset()">
        Cancelar
      </button>
      <button
        type="submit"
        class="btn btn-blue-ml"
        style="border-radius: 30px; border-top-left-radius: 0"
      >
        Salvar
      </button>
    </div>
  </form>
</template>

<script>
import InputAvatar from "@/components/media/InputAvatar.vue";
import LoaderContent from "@/components/loader/LoaderContent.vue";
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
import FormQuestions from "@/components/subscription/Questions/FormQuestions.vue";
import MedicalReport from "@/components/subscription/PersonalData/MedicalReport.vue";
import IconHelpCircleOutline from "vue-material-design-icons/HelpCircleOutline.vue";
export default {
  name: "FormPersonalData",
  data() {
    return {
      firstname: "",
      lastname: "",
      socialName: "",
      email: "",
      nationality: "Brasil",
      document_label: "CPF",
      cpf: "",
      cpfReadOnly: false,
      passport: "",
      passportReadOnly: false,
      gender: "",
      sexualOrientation: "",
      raceAndEthnicity: "",
      pronoun: "",
      personalIncome: "",
      familyIncome: "",
      maritalStatus: "",
      phone: "",
      birthday: "",
      has_disability: false,
      disabilities: [],
      need_help_selection_process: false,
      description_help_selection_process: "",
      medical_report: "",
      zipcode: "",
      street: "",
      number: "",
      complement: "",
      neighborhood: "",
      state: "",
      city: "",
      whatDoYouLove: "",
      birthdayMessage: null,
      nationalitySettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: "body",
      },
      genderSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: "body",
      },
      sexualOrientationSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: "body",
      },
      raceAndEthnicitySettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: "body",
      },
      pronounSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: "body",
      },
      personalIncomeSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: "body",
      },
      maritalStatusSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: "body",
      },
      familyIncomeSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: "body",
      },
      stateSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: "body",
        onChange: (value) => {
          this.state = value;
          this.$store.dispatch(
            "graphql_queries/query",
            `
              domains(state: "${
                this.$store.state.domains.states.find((st) => st.id == value)[
                  "abbr"
                ]
              }") {
                cities {id, name, abbr},
              }
            `
          );
        },
      },
      citySettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: "body",
      },
      isLoading: false,
      source: "chatbot",
    };
  },
  props: {
    hasButtons: {
      type: Boolean,
      default: false,
    },
    storeByEventBus: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    caharactersLeft() {
      let char = this.description_help_selection_process.length;
      const limit = 100;
      return limit - char + " / " + limit;
    },
    isForeign() {
      return this.nationality &&
        this.nationality.toLowerCase().indexOf("brasil") != -1
        ? false
        : true;
    },
  },
  watch: {
    has_disability: function (newValue, oldValue) {
      if (!newValue || newValue == false) {
        this.disabilities = [];
      }
    },
  },
  mixins: [validationMixin],
  validations: {
    firstname: { required },
    lastname: { required },
    socialName: {},
    email: { required },
    nationality: { required },
    cpf: {
      required: requiredIf(function (value) {
        return !this.isForeign;
      }),
    },
    passport: {
      required: requiredIf(function (value) {
        return this.isForeign;
      }),
    },
    phone: {
      required,
      isValid: (value, _this) => {
        if (!value) return false;
        var phone = value.replace(/[^0-9]/g, "");
        return phone.match(/^(\d)\1+$/g) ? false : true;
      },
    },
    birthday: {
      required,
      isDate: (value, _this) => {
        let year = value.split("/")[2];
        const current_year = new Date().getFullYear(); // ano atual
        const age = current_year - year;
        if (age < 10) {
          _this.birthdayMessage = "Data inválida";
          return false;
        }
        if (age > 100) {
          _this.birthdayMessage = "Data inválida";
          return false;
        }
        if (
          _this.$moment(`${value.split("/").reverse().join("-")}`).isValid() ==
          false
        ) {
          _this.birthdayMessage = "Data inválida";
          return false;
        }
        _this.birthdayMessage = null;
        return true;
      },
    },
    gender: { required },
    sexualOrientation: { required },
    raceAndEthnicity: { required },
    pronoun: { required },
    personalIncome: { required },
    familyIncome: { required },
    zipcode: { required },
    street: { required },
    number: { required },
    neighborhood: { required },
    state: { required },
    city: { required },
    has_disability: { required },
    disabilities: {
      required: requiredIf(function (value) {
        return this.has_disability == true;
      }),
    },
    description_help_selection_process: {},
  },
  components: {
    InputAvatar,
    LoaderContent,
    FormQuestions,
    MedicalReport,
    IconHelpCircleOutline,
  },
  mounted() {
    this.initListeners();
    setTimeout(() => this.removeAutoFillSelectize(), 500);
  },
  destroyed() {
    this.$EventBus.$off("editingPersonalData");
    this.$EventBus.$off("storePersonalDataForm");
    this.$store.commit("PERSONAL_DATA_FORM", {});
  },
  methods: {
    showModalDiversityInput() {
      this.$EventBus.$emit("showModalDiversityInputs", "modal-personal-data");
    },
    initListeners() {
      this.$EventBus.$on("editingPersonalData", () => {
        this.isLoading = true;
        const profile = this.$store.state.user.profile;
        this.firstname = profile.firstname;
        this.lastname = profile.lastname;
        this.socialName = profile.socialName;
        this.email = profile.email;
        this.nationality = profile.nationality
          ? profile.nationality
          : profile.passport
          ? ""
          : "Brasil";
        this.cpf = profile.cpf;
        this.cpfReadOnly = this.cpf != null && this.cpf.length > 0;
        this.passport = profile.passport;
        this.passportReadOnly =
          this.passport != null && this.passport.length > 0;
        this.gender = profile.gender;
        this.raceAndEthnicity = profile.raceAndEthnicity;
        this.pronoun = profile.pronoun;
        this.familyIncome = profile.familyIncome;
        this.personalIncome = profile.personalIncome;
        this.sexualOrientation = profile.sexualOrientation;
        this.maritalStatus = profile.maritalStatus;
        this.phone = profile.phone;
        this.birthday = this.$moment(profile.birthday).format("DD/MM/YYYY");
        this.disabilities = profile.disabilities.map(
          (disability) => disability.disabilityId
        );
        this.has_disability =
          profile.hasDisability || this.disabilities.length > 0;
        this.whatDoYouLove = profile.whatDoYouLove;
        if (profile.location) {
          this.zipcode = profile.location.zipcode;
          this.street = profile.location.street;
          this.number = profile.location.number;
          this.complement = profile.location.complement;
          this.neighborhood = profile.location.neighborhood;
          this.state = profile.location.stateId;
          if (this.state) {
            this.$store
              .dispatch(
                "graphql_queries/query",
                `
                domains(state: "${
                  this.$store.state.domains.states.find(
                    (st) => st.id == this.state
                  )["abbr"]
                }") {
                  cities {id, name, abbr},
                }
              `
              )
              .then(() => {
                this.city = this.$helpers.cleanStringToCompare(
                  profile.location.city
                );
              });
          }
        }
        this.isLoading = false;
      });
      this.$EventBus.$on("storePersonalDataForm", this.storeForm);
    },
    reset(closeModal = true) {
      this.isLoading = false;
      this.$v.$reset();
      if (closeModal) this.$emit("closeModal");
      Object.assign(this.$data, this.$options.data.call(this));
      this.initListeners();
    },
    getAddress() {
      if (this.zipcode != null && this.zipcode.replace(/\D/g, "").length != 8)
        return false;
      this.$store
        .dispatch("location/addressByZipCode", this.zipcode)
        .then((address) => {
          this.street = address.logradouro;
          this.number = "";
          this.complement = "";
          this.neighborhood = address.bairro;
          this.state = this.$store.state.domains.states.find(
            (st) => st.abbr.toUpperCase() == address.uf.toUpperCase()
          )["id"];
          this.$store
            .dispatch(
              "graphql_queries/query",
              `
            domains(state: "${
              this.$store.state.domains.states.find(
                (st) => st.id == this.state
              )["abbr"]
            }") {
              cities {id, name, abbr},
            }
          `
            )
            .then(() => {
              this.city = this.$helpers.cleanStringToCompare(
                address.localidade
              );
            });
        });
    },
    saveForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
      } else {
        const data = this.$data;
        this.$store
          .dispatch("user/personalDataUpdate", data)
          .then((response) => {
            if (response.error) {
              this.$swal(
                "Uoops",
                "Ocorreu um erro ao salvar suas informações",
                "error"
              );
            } else {
              this.$store
                .dispatch(
                  "graphql_queries/query",
                  `
                user( id: "${this.$store.state.user.profile.id}" ){
                  profile{
                    firstname,
                    lastname,
                    socialName,
                    email,
                    nationality,
                    cpf,
                    passport,
                    gender,
                    sexualOrientation,
                    raceAndEthnicity,
                    pronoun,
                    personalIncome,
                    maritalStatus,
                    phone,
                    birthday,
                    whatDoYouLove,
                    familyIncome,
                    descriptionHelpSelectionProcess,
                    needHelpSelectionProcess,
                    location {
                      zipcode,
                      street,
                      number,
                      complement,
                      neighborhood,
                      stateId,
                      city
                    },
                    disabilities {
                      disabilityId,
                      name
                    },
                  }
                }
              `
                )
                .then((updatedData) => {
                  this.$swal(
                    "Pronto!",
                    "Dados pessoais salvo com sucesso",
                    "success"
                  );
                  this.reset();
                });
            }
          });
      }
    },
    storeForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$store.commit("PERSONAL_DATA_FORM", {
          error: true,
        });
        setTimeout(() => {
          Array.from(this.$el.querySelectorAll(".is-invalid")).some((field) => {
            field.querySelector("input").focus();
            return field;
          });
        }, 100);
      } else {
        this.$store.commit("PERSONAL_DATA_FORM", {
          data: this.$data,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-group {
  margin-bottom: 0.5rem;
  &:not(.divider-container) {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  hr {
    margin-bottom: 0.4rem;
    margin-top: 0.4rem;
  }
}
.limiter {
  color: red;
}
</style>